import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Card, CardHeader, CardFooter, CardBody, Row, Col, Alert } from 'reactstrap';
import { metadataService, userService } from "../../_services";
import { SlButton, SlBranchDisplay, SlBusyIndicator, SLDetailsTable } from "../editors";
import LeadDocuments from './LeadDocuments';
import Persona from './Persona';

class LeadInfoView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sunLoanBranch: {},
            isWorking: false,
            isMyDocumentsEnabled: false,
            isSMSForDocumentsEnabled: false,
            showDocumentsNeeded: props.showDocumentsNeeded
        };
    }

   async componentDidMount() {
       if (this.props.lead.fundDelivery) {
           this.onInquiryStatusUpdate(this.props.lead.inquiryStatus);
           this.setState({isWorking: true});
           const [getBranchResponse, isMyDocumentsEnabledResponse, isSMSForDocumentsEnabledResponse] = await Promise.all([metadataService.getBranch(this.props.lead.branchId), userService.isMyDocumentsEnabled(), userService.isSMSForDocumentsEnabled()])           
           this.setState({ isWorking: false, sunLoanBranch: getBranchResponse.data, isMyDocumentsEnabled: isMyDocumentsEnabledResponse, isSMSForDocumentsEnabled:  isSMSForDocumentsEnabledResponse});
       }
    }

    getLeadDescription(lead) {
        switch (lead.leadType) {
            case 7:
                return metadataService.getLabel("RefinanceLoanRequest");
            case 8:
                return metadataService.getLabel("IncreaseLoanRequest");
            default:
                return metadataService.getLabel("NewLoanRequest");
        }
    }

    onInquiryStatusUpdate(newStatus) {
        if (newStatus && this.props.usePersona) {

            if (newStatus !== "created" && newStatus !== "pending")
                this.setState({ showDocumentsNeeded: false })
        }
    }

    render() {
        const { isMyDocumentsEnabled, isWorking, isSMSForDocumentsEnabled } = this.state;     

        return (
          <div>
            <Card className="lead-info-view-card pl-0 ml-0">
              <CardHeader className="bg-primary ">
                <b>{this.getLeadDescription(this.props.lead)}</b>
              </CardHeader>
              <SlBusyIndicator visible={isWorking} />
              {isWorking == false && (
                <div>
                  {this.props.lead.status == 2 && (
                    <CardFooter>
                      <Row>
                        <Col>
                          <div className="lead-info-application-status">
                            {metadataService.getLabel("ApplicationComplete")}
                          </div>
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col sm="2"></Col>
                        <Col sm="8">
                          {metadataService.getMessage(
                            "YourLoanApplicationHasBeenCompleted"
                          )}
                        </Col>
                        <Col sm="2"></Col>
                      </Row>
                      <br />
                      <Row>
                        <Col sm="2"></Col>
                        <Col sm="8">
                          {this.props.lead.fundDelivery === 1 &&
                            metadataService.getMessage(
                              "ApplicationCompletedElectronic"
                            )}
                          {this.props.lead.fundDelivery === 2 &&
                            metadataService.getMessage(
                              "ApplicationCompletedInPerson"
                            )}
                        </Col>
                        <Col sm="2"></Col>
                      </Row>
                      <br />
                      {this.props.lead.fundDelivery === 2 && (
                        <div>
                          <SlBusyIndicator visble={this.state.isWorking} />

                          {!this.state.isWorking && (
                            <div>
                              <Row>
                                <Col sm="4"></Col>
                                <Col sm="4">
                                  <SlBranchDisplay
                                    sunLoanBranch={this.state.sunLoanBranch}
                                  />
                                </Col>
                                <Col sm="4"></Col>
                              </Row>
                              <br />
                            </div>
                          )}
                        </div>
                      )}
                      <Row>
                        <Col sm="2"></Col>
                        <Col sm="8">
                          {metadataService.getMessage("IfYouHaveAnyQuestions")}
                        </Col>
                        <Col sm="2"></Col>
                      </Row>
                    </CardFooter>
                  )}

                  {this.props.lead.status === 3 && (
                    <CardFooter>
                      <Row>
                        <Col>
                          <div className="lead-info-application-status">
                            {metadataService.getLabel("ApplicationDeclined")}
                          </div>
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col sm="2"></Col>
                        <Col sm="8">
                          <span>
                            {metadataService.getMessage(
                              "UnfortunatelyUnableToProcess90Days"
                            )}
                          </span>                        
                        </Col>
                        <Col sm="2"></Col>
                      </Row>
                    </CardFooter>
                  )}

                  {this.props.lead.status === 4 && (
                    <CardFooter>
                      <Row>
                        <Col>
                          <div className="lead-info-application-status">
                            {metadataService.getLabel("ApplicationWithdrawn")}
                          </div>
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col sm="2"></Col>
                        <Col sm="8">
                          {metadataService.getMessage("WeStillNeedInformation")}
                        </Col>
                        <Col sm="2"></Col>
                      </Row>
                    </CardFooter>
                  )}

                  {this.props.lead.status === 5 &&
                    !this.state.showDocumentsNeeded && (
                      <CardFooter>
                        <Row>
                          <Col>
                            <div className="lead-info-application-status">
                              {metadataService.getLabel("ApplicationInProcess")}
                            </div>
                          </Col>
                        </Row>
                        <br />
                        <Row>
                          <Col sm="2"></Col>
                          <Col sm="8">
                            <div>
                              {metadataService.getMessage(
                                "OneOfOurRepresentatives"
                              )}
                            </div>
                          </Col>
                          <Col sm="2"></Col>
                        </Row>
                      </CardFooter>
                    )}

                  {this.state.showDocumentsNeeded && !isMyDocumentsEnabled && (
                    <CardFooter>
                      <Row>
                        <Col>
                          <div className="lead-info-application-status">
                            {metadataService.getLabel("ApplicationInProcess")}
                          </div>
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col sm="2"></Col>
                        <Col sm="8">
                          <div>
                            {metadataService.getMessage(
                              "OneOfOurRepresentatives"
                            )}
                          </div>
                        </Col>
                        <Col sm="2"></Col>
                      </Row>
                    </CardFooter>
                  )}

                  {(this.state.showDocumentsNeeded && isMyDocumentsEnabled) && (
                    <CardBody>
                     
                      <Row>
                        <Col>
                            {this.props.usePersona ?
                                <Persona leadId={this.props.lead.leadId} onInquiryStatusUpdate={this.onInquiryStatusUpdate} /> :
                                <LeadDocuments isSMSForDocumentsEnabled={isSMSForDocumentsEnabled} />
                            }
                        </Col>
                      </Row>
                    </CardBody>
                  )}

                  <CardBody>
                    <Row>
                      <Col>
                        <SLDetailsTable
                          dataSource={[
                            {
                              label:
                                metadataService.getFieldNameLabel(
                                  "RequestDate"
                                ),
                              value: metadataService.formatDateString(
                                this.props.lead.timestamp
                              ),
                            },
                            {
                              label:
                                metadataService.getFieldNameLabel("Status"),
                              value: metadataService.getLookupText(
                                "leadStatus",
                                this.props.lead.status
                              ),
                            },
                          ]}
                        />
                      </Col>
                    </Row>
                  </CardBody>
                </div>
              )}
            </Card>
          </div>
        );
    }
}
//Declare our proptypes. 
LeadInfoView.propTypes = {
    //This lead JSON object. 
    lead: PropTypes.object.isRequired,
    showDocumentsNeeded: PropTypes.bool
}

const mapStateToProps = (state) => {
    const {
        idDocumentsLoading,
      } = state.documents; 
      const {language} = state.users
    return {
        idDocumentsLoading,
        language
    };
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {};
  };
  

  const connectedLeadInfoView = connect(mapStateToProps, mapDispatchToProps)(LeadInfoView)
  export  {connectedLeadInfoView as LeadInfoView}
  